import { CONFIGURATION } from "@revolt/common";

/** The backend route that starts the OIDC browser redirect flow. */
export function oidcLoginUrl(): string {
  return `${CONFIGURATION.DEFAULT_API_URL}/auth/oidc/login`;
}
